import { render, staticRenderFns } from "./FontStyleIcon.vue?vue&type=template&id=3a5575aa&"
import script from "./FontStyleIcon.vue?vue&type=script&lang=js&"
export * from "./FontStyleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports